import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { LucideIconsModule } from '../../lucide-icons.module';
import { ReportExportFormat } from '../../utils/report-export.util';

@Component({
    selector: 'app-export-report-menu',
    standalone: true,
    imports: [CommonModule, LucideIconsModule],
    templateUrl: './export-report-menu.component.html'
})
export class ExportReportMenuComponent {
    @Input() disabled = false;
    @Input() exportingFormat: ReportExportFormat | null = null;
    @Output() exportFormat = new EventEmitter<ReportExportFormat>();

    open = false;

    toggle(event: Event): void {
        event.stopPropagation();
        if (this.disabled || this.exportingFormat) return;
        this.open = !this.open;
    }

    choose(format: ReportExportFormat, event: Event): void {
        event.stopPropagation();
        if (this.disabled || this.exportingFormat) return;
        this.open = false;
        this.exportFormat.emit(format);
    }

    @HostListener('document:click')
    close(): void {
        this.open = false;
    }
}
